import React from 'react';
import { Container } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import IntlMessage from '../../../helpers/intlMessage';

function Recptacullos ({ lista }) {

  function RenderizarFooter({ total, text }) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <i className="mv-basico-stacktrace" style={{ fontSize: '20px', height: '-150px' }} />{' '}
          <span style={{ marginTop: '2px', fontSize: '14px' }} id="total-exames">
            {text}: {total} <IntlMessage id="dashboards.disposalMaterials.table.items"/>
          </span>
        </span>
      </div>
    );
  }

  return (
    <Container fluid className='mv-workspace-container'>
      <DataTable
        value={lista}
        responsive={true}
        selectionMode='single'
        style={{ height: '70vh' }}
        columnResizeMode='expand'
        scrollable={true}
        scrollHeight='71vh'
        scrollWidth='100%'
        resizableColumns={true}
        reorderableColumns={true}
        rowsPerPageOptions={[10, 20, 50]}
        lazy={false}
        paginator={false}
        emptyMessage={<IntlMessage id = "dashboards.taskControl.noResult"/>}
        footer={<RenderizarFooter text={'Total'} total={lista.length} />}
        alwaysShowPaginator={true}
        autoLayout={true}
        totalRecords={lista.length}
        onSelectionChange={e => {}}
      >
        <Column
          sortable={true}
          field='nrExame'
          style={{ width: '150px' }}
          header={<IntlMessage id="dashboards.taskControl.exam"/>}
        />

        <Column
          sortable={true}
          field='nrBloco'
          style={{ width: '200px' }}
          header={<IntlMessage id="dashboards.taskControl.block"/>}
        />
        <Column
          sortable={true}
          field='numeroFragmentos'
          style={{ width: '180px' }}
          header={<IntlMessage id="dashboards.taskControl.fragments"/>}
        />
     
        <Column
          sortable={true}
          field='macroscopista'
          style={{ width: '250px' }}
          header={<IntlMessage id="dashboards.taskControl.macroscopist"/>}
        />
        <Column
          sortable={true}
          field='tipoCassete'
          style={{ width: '150px' }}
          header={<IntlMessage id="dashboards.taskControl.typeCassette"/>}
        />
        <Column
          sortable={true}
          field='material'
          style={{ width: '200px' }}
          header={<IntlMessage id="dashboards.taskControl.material"/>}
        />
        <Column
          sortable={true}
          field='coloracao'
          style={{ width: '250px' }}
          header={<IntlMessage id="dashboards.taskControl.coloring"/>}
        />
        <Column
          sortable={true}
          field='urgencia'
          style={{ width: '120px' }}
          header={<IntlMessage id="dashboards.taskControl.urgency"/>}
        />
        <Column
          sortable={true}
          field='novosCortes'
          style={{ width: '80px' }}
          header={<IntlMessage id="dashboards.taskControl.nc"/>}
        />
      </DataTable>
    </Container>
  );
}

export default Recptacullos;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Recptaculos/index.js